import React, { useMemo, useState, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import ReCAPTCHA from 'react-google-recaptcha';

const SMTP2GO_API_KEY = 'api-69E86B4DC274407BBF54F74BFBBF02B6';
const FROM_EMAIL = 'site@tinkerlabs.org';
const TO_EMAIL1 = "franchise@tinkerlabs.org";
const TO_EMAIL2 = "wgucmbcr@mailparser.io";
const TO_EMAIL = "admin@tinkerlabs.ba";
// Replace with your reCAPTCHA site key
const RECAPTCHA_SITE_KEY = "6LeWyTkrAAAAAPfoKmWTaOPP2Vj4XAcE-edji8Fe";

const US_STATE_OPTIONS = [
  { value: 'Alabama', label: 'Alabama' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Arizona', label: 'Arizona' },
  { value: 'Arkansas', label: 'Arkansas' },
  { value: 'California', label: 'California' },
  { value: 'Colorado', label: 'Colorado' },
  { value: 'Connecticut', label: 'Connecticut' },
  { value: 'Delaware', label: 'Delaware' },
  { value: 'Florida', label: 'Florida' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'Idaho', label: 'Idaho' },
  { value: 'Illinois', label: 'Illinois' },
  { value: 'Indiana', label: 'Indiana' },
  { value: 'Iowa', label: 'Iowa' },
  { value: 'Kansas', label: 'Kansas' },
  { value: 'Kentucky', label: 'Kentucky' },
  { value: 'Louisiana', label: 'Louisiana' },
  { value: 'Maine', label: 'Maine' },
  { value: 'Maryland', label: 'Maryland' },
  { value: 'Massachusetts', label: 'Massachusetts' },
  { value: 'Michigan', label: 'Michigan' },
  { value: 'Minnesota', label: 'Minnesota' },
  { value: 'Mississippi', label: 'Mississippi' },
  { value: 'Missouri', label: 'Missouri' },
  { value: 'Montana', label: 'Montana' },
  { value: 'Nebraska', label: 'Nebraska' },
  { value: 'Nevada', label: 'Nevada' },
  { value: 'New Hampshire', label: 'New Hampshire' },
  { value: 'New Jersey', label: 'New Jersey' },
  { value: 'New Mexico', label: 'New Mexico' },
  { value: 'New York', label: 'New York' },
  { value: 'North Carolina', label: 'North Carolina' },
  { value: 'North Dakota', label: 'North Dakota' },
  { value: 'Ohio', label: 'Ohio' },
  { value: 'Oklahoma', label: 'Oklahoma' },
  { value: 'Oregon', label: 'Oregon' },
  { value: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'Rhode Island', label: 'Rhode Island' },
  { value: 'South Carolina', label: 'South Carolina' },
  { value: 'South Dakota', label: 'South Dakota' },
  { value: 'Tennessee', label: 'Tennessee' },
  { value: 'Texas', label: 'Texas' },
  { value: 'Utah', label: 'Utah' },
  { value: 'Vermont', label: 'Vermont' },
  { value: 'Virginia', label: 'Virginia' },
  { value: 'Washington', label: 'Washington' },
  { value: 'West Virginia', label: 'West Virginia' },
  { value: 'Wisconsin', label: 'Wisconsin' },
  { value: 'Wyoming', label: 'Wyoming' },
];

const FranchiseForm = ({toSection,section,bgColor="#B8E1FF",marginBottom=0}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: null,
    state: null,
    city: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef();

  const countryOptions = useMemo(() => (
    countryList().getData().map(country => ({
      value: country.value,
      label: country.label,
    }))
  ), []);

  const isUnitedStatesSelected = formData.country?.value === 'US' || formData.country?.label === 'United States';

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate reCAPTCHA
    if (!captchaValue) {
      setSubmitStatus('captcha-error');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus(null);

    const emailPayload = {
        api_key: SMTP2GO_API_KEY,
        to: [TO_EMAIL,TO_EMAIL1,TO_EMAIL2],
        sender: FROM_EMAIL,
        subject: "New Franchise Information Request",
        html_body: `
          <h2>New Franchise Information Request</h2>
          <p><strong>Name:</strong> ${formData.firstName} ${formData.lastName}</p>
          <p><strong>Email:</strong> ${formData.email}</p>
          <p><strong>Phone:</strong> ${formData.phone}</p>
          <p><strong>Country:</strong> ${formData.country?.label}</p>
          ${formData.state?.label ? `<p><strong>State:</strong> ${formData.state?.label}</p>` : ''}
          <p><strong>City:</strong> ${formData.city}</p>
        `,
        text_body: `
          New Franchise Information Request
          
          Name: ${formData.firstName} ${formData.lastName}
          Email: ${formData.email}
          Phone: ${formData.phone}
          Country: ${formData.country?.label}
          ${formData.state?.label ? `State: ${formData.state?.label}\n` : ''}
          City: ${formData.city}
        `
      };
  
      try {
        const response = await fetch('https://api.smtp2go.com/v3/email/send', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(emailPayload)
        });
  
        const data = await response.json();
  
        if (data.data?.succeeded) {
          setSubmitStatus('success');
          setFormData({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            city:'',
            country: null,
            state: null,
          });
          // Reset reCAPTCHA
          recaptchaRef.current.reset();
          setCaptchaValue(null);
        } else {
          setSubmitStatus('error');
          console.error('Email error:', data.data?.error);
        }
      } catch (error) {
        console.error('Submission error:', error);
        setSubmitStatus('error');
      }
  
      setIsSubmitting(false);
    };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: '2px',
      borderRadius: '0.5rem',
      border: '1px solid #e2e8f0',
      boxShadow: 'none',
      '&:hover': {
        border: '1px solid #e2e8f0',
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#1678F2' : state.isFocused ? '#e2e8f0' : 'white',
      color: state.isSelected ? 'white' : '#1a202c',
    }),
  };

  return (
    <div id="contact-form" style={{marginTop: '-40px',marginBottom:marginBottom}} className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill={bgColor}
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div style={{ backgroundColor: bgColor }} className="relative py-20">
        <div className="container mx-auto px-4">
        <div className="container mx-auto px-4">
        <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-[#002147] mb-4">
        Join Europe's Fastest-Growing STEAM Franchise
        </h2>
         
        <p className="text-center text-[#002147] mb-12 font-['Lexend']">
        With over 120 locations in 7 countries across Europe, Tinker Labs is a recognized leader in STEAM education.  Our rapid growth shows that parents and communities highly value our approach to learning, while our franchise partners see it as more than an investment, but a commitment to changing the world - one young mind at a time
        </p>

     
      </div>
          <div className="bg-[#002147] rounded-xl p-8 max-w-3xl mx-auto shadow-xl">
            <h2 className="font-['Grandstander'] text-3xl font-bold text-white text-center mb-8">
              Franchise Info Request
            </h2>

            {submitStatus === 'success' && (
              <div className="mb-4 p-4 bg-green-100 text-green-700 rounded-lg">
                Thank you for your interest! We'll be in touch soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg">
                Sorry, something went wrong. Please try again later.
              </div>
            )}

            {submitStatus === 'captcha-error' && (
              <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg">
                Please verify that you are not a robot.
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6 font-['Lexend']">
              <div>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First Name"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1678F2]"
                />
              </div>

              <div>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last Name"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1678F2]"
                />
              </div>

              <div>
                <PhoneInput
                   inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: true
                  }}
                   value={formData.phone}
                  onChange={phone => setFormData(prev => ({ ...prev, phone }))}
                  inputStyle={{
                    width: '100%',
                    height: '48px',
                    fontSize: '16px',
                    borderRadius: '0.5rem',
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                  buttonStyle={{
                    borderRadius: '0.5rem 0 0 0.5rem',
                  }}
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1678F2]"
                />
              </div>

              <div>
                <Select
                  options={countryOptions}
                  value={formData.country}
                  onChange={(country) => setFormData(prev => ({
                    ...prev,
                    country,
                    state: (country?.value === 'US' || country?.label === 'United States') ? prev.state : null,
                  }))}
                  placeholder="Select Country"
                  required
                  styles={customStyles}
                  className="text-gray-800"
                />
              </div>
              
              {isUnitedStatesSelected && (
                <div>
                  <Select
                    options={US_STATE_OPTIONS}
                    value={formData.state}
                    onChange={(state) => setFormData(prev => ({ ...prev, state }))}
                    placeholder="Select State"
                    required
                    styles={customStyles}
                    className="text-gray-800"
                  />
                </div>
              )}

              <div>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  placeholder="City"
                  className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1678F2]"
                />
              </div>

              {/* Google reCAPTCHA */}
              <div className="flex justify-center">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaChange}
                  theme="dark"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-3 px-6 bg-[#F18917] text-white rounded-full font-semibold transition-colors duration-300 ${
                  isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#F18917]'
                }`}
              >
                {isSubmitting ? 'Sending...' : 'Send me more info'}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill={bgColor}
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default FranchiseForm;